import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./components/auth/AuthContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import LoginForm from "./components/auth/LoginForm";
import ForgotPasswordForm from "./components/auth/ForgotPasswordForm";
import ChangePasswordForm from "./components/auth/ChangePasswordForm";
import Dashboard from "./components/dashboard/Dashboard";
import Settings from "./components/dashboard/Settings";
import SupplierOfferForm from "./components/quotation/SupplierQuotationResponse";
import History from "./components/history/History";
import HistoryDetails from './components/history/HistoryDetails';

function App() {
	return (
		<AuthProvider>
			<BrowserRouter>
				<Routes>
					<Route path="/login" element={<LoginForm />} />
					<Route path="/forgot-password" element={<ForgotPasswordForm />} />
					<Route path="/change-password" element={<ChangePasswordForm />} />
					<Route
						path="/dashboard"
						element={
							<ProtectedRoute>
								<Dashboard />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/settings"
						element={
							<ProtectedRoute>
								<Settings />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/rfq/:rfqId/offer"
						element={
							<ProtectedRoute>
								<SupplierOfferForm />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/history"
						element={
							<ProtectedRoute>
								<History />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/rfq/:rfqId/history"
						element={
							<ProtectedRoute>
								<HistoryDetails />
							</ProtectedRoute>
						}
					/>
					{/* Redirect all other routes to dashboard */}
					<Route path="*" element={<Navigate to="/dashboard" />} />
				</Routes>
			</BrowserRouter>
		</AuthProvider>
	);
}

export default App;
